import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './paysub.routes';
import addHtml from './modal/add.html';

export class PaySubController {
    $http;
    socket;
    paysubs = [];
    newThing = '';

    /*@ngInject*/
    constructor($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location) {
        this.$http = $http;
        this.socket = socket;
        this.$uibModal = $uibModal;
        this.$cookies = $cookies;
        this.$cookieStore = $cookieStore;
        this.$location = $location;


        this.subStatus = [
            { value: '终身', name: '终身' },
            { value: '订阅中', name: '订阅中' },
            { value: '已过期', name: '已过期' },
            { value: '订阅中[赠]', name: '订阅中[赠]' },
            { value: '已过期[赠]', name: '已过期[赠]' },
        ]

        $scope.$on('$destroy', function () {
            socket.unsyncUpdates('paysub');
        });
    }



    $onInit() {

        if (this.$cookies.get('token')) {
            this.$http.get('/api/pay_sub/', {
                header: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'token': this.$cookies.get('token')
                },
                params: {
                    'page': 0,
                    'size': 20
                }
            })
                .then(response => {
                    if (response.data.data) {


                        this.maxSize = 20;
                        this.totalCount = response.data.count;
                        this.totalItems = response.data.count / 2;
                        this.currentPage = 1;

                        this.paysubs = response.data.data;
                        this.socket.syncUpdates('paysubs', this.paysubs);
                    }

                });
        } else {
            this.$location.path('main')
        }
    }

    search(val) {
        if (val === true) {
            this.currentPage = 1;
        }
        const payload = angular.copy(this.filters);



        const ret = {
            filters: payload || {},
            page: this.currentPage - 1,
            size: 20
        };
        if (this.$cookies.get('token')) {

            this.$http.get('/api/pay_sub/', {
                header: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'token': this.$cookies.get('token')
                },
                params: ret
            })
                .then(response => {
                    if (response.data.data) {
                        this.maxSize = 20;
                        this.totalCount = response.data.count;
                        this.totalItems = response.data.count / 2;
                        this.paysubs = response.data.data;

                        this.socket.syncUpdates('paysubs', this.paysubs);
                    }
                });
        } else {
            this.$location.path('main')
        }
    }

    addPaysub() {
        const paysubs = this.paysubs;
        this.$uibModal.open({
            template: addHtml,
            size: 'lg',
            /*@ngInject*/
            controller: function ($scope, $http, $uibModalInstance) {
                $scope.vm = {};
                $scope.platformTypes = ['Android', 'ios'];
                $scope.isDisabled = false;
                $scope.popup2 = {
                    opened: false
                };

                $scope.open2 = function () {
                    $scope.popup2.opened = true;
                };

                $scope.save = function (myForm) {
                    if (myForm.$valid === false) {
                        return false;
                    } else {
                        let data = {
                            user_id: $scope.vm.user_id,
                            platform: $scope.vm.platform,
                            pay_id: $scope.vm.platform + $scope.vm.user_id,
                            expires_date_ms: $scope.vm.expires_date_ms.getTime(),
                            is_give: 1,
                        }
                        $http.post('/api/pay_sub/1/', data).then((response) => {
                            $uibModalInstance.close(response.data.data);
                        }, (error) => {
                            console.log(error);
                        });
                    }
                };
                $scope.cancel = function () {
                    $uibModalInstance.close();
                };
            }
        })
            .result.then(function (ret) {
                if (ret) {
                    paysubs.push(ret);
                }
            }, function () {
            });
    }

    updatePaysub(paysub, index) {
        const paysubs = this.paysubs;
        this.$uibModal.open({
            template: addHtml,
            size: 'lg',
            /*@ngInject*/
            controller: function ($scope, $http, $uibModalInstance) {
                let copyData = angular.copy(paysub);
                $scope.popup2 = {
                    opened: false
                };

                $scope.open2 = function () {
                    $scope.popup2.opened = true;
                };
                $scope.vm = {
                    user_id: copyData.user_id,
                    platform: copyData.platform,
                    pay_id: copyData.pay_id,
                    expires_date_ms: new Date(parseInt(copyData.expires_date_ms, 10)),
                }
                $scope.platformTypes = ['Android', 'ios'];
                $scope.isDisabled = true;
                $scope.save = function (myForm) {
                    if (myForm.$valid === false) {
                        return false;
                    } else {
                        let data = {
                            expires_date_ms: $scope.vm.expires_date_ms.getTime(),
                        }
                        $http.put('/api/pay_sub/' + $scope.vm.platform + $scope.vm.user_id + '/', data).then((response) => {
                            let date = data.expires_date_ms;
                            $uibModalInstance.close({ req: response.data.data, date: date });
                        }, (error) => {
                            console.log(error);
                        });
                    }
                };
                $scope.cancel = function () {
                    $uibModalInstance.close();
                };
            }
        })
            .result.then(function (ret) {
                if (ret.req) {
                    paysubs[index]['expires_date_ms'] = ret.date;
                }
            }, function () {
            });
    }
}

export default angular.module('tttApp.paysub', [uiRouter])
    .config(routing)
    .component('paysub', {
        template: require('./paysub.html'),
        controller: PaySubController
    })
    .name;



// WEBPACK FOOTER //
// ./client/app/paysub/paysub.component.js